import { render, staticRenderFns } from "./SeletorClientesAvancado.vue?vue&type=template&id=476ac7a4&scoped=true"
import script from "./SeletorClientesAvancado.vue?vue&type=script&lang=js"
export * from "./SeletorClientesAvancado.vue?vue&type=script&lang=js"
import style0 from "./SeletorClientesAvancado.vue?vue&type=style&index=0&id=476ac7a4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "476ac7a4",
  null
  
)

export default component.exports